import { render } from "./recruitmentDetail.vue?vue&type=template&id=4833e4d0&scoped=true"
import script from "./recruitmentDetail.vue?vue&type=script&lang=js"
export * from "./recruitmentDetail.vue?vue&type=script&lang=js"

import "./recruitmentDetail.vue?vue&type=style&index=0&id=4833e4d0&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4833e4d0"]])

export default __exports__